const state = {
  maxWallDimension: 680,
  // feetMagnification: 3.281,
  feetMagnification: 3.28,
  magnification: 1,
  resolutionType: null,
  resolutionWidth: 0,
  resolutionHeight: 0,
  resolutionPossible: false,
  resolutionEventMode: null,
}

const getters = {}

const mutations = {
  setMagnification(state, payload) {
    const magnification = payload === `METER` ? 1 : state.feetMagnification
    state.magnification = magnification
  },
  setResolutionEventMode(state, payload) {
    state.resolutionEventMode = payload
  },
  setCurrentResolution(state, payload) {
    state.resolutionType = payload
    if (state.resolutionType === `FHD`) {
      state.resolutionWidth = 1920
      state.resolutionHeight = 1080
    }
    if (state.resolutionType === `UHD`) {
      state.resolutionWidth = 3840
      state.resolutionHeight = 2160
    }
  },
  setResolutionSize(state, payload) {
    if (payload === `FHD`) {
      state.resolutionWidth = 1920
      state.resolutionHeight = 1080
    }
    if (payload === `UHD`) {
      state.resolutionWidth = 3840
      state.resolutionHeight = 2160
    }
  },
  resetCurrentResolutionType(state) {
    state.resolutionType = null
    state.resolutionWidth = 0
    state.resolutionHeight = 0
  },
  setResolutionPossible(state, payload) {
    state.resolutionPossible = payload
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
